<template>
    <div class="about-dizhi center-wrapper">
      <div class="about-dizhi-left">
        <div class="about-dizhi-left-top">
          <h1 class="about-dizhi-title">咨询业务</h1>
          <ul class="about-dizhi-left-top-content" style="margin-top: 5px;">
            <li v-for="item of zxywList1" :key="item">
              {{item}}
            </li>
          </ul>
          <ul class="about-dizhi-left-top-content">
            <li v-for="item of zxywList2" :key="item">
              {{item}}
            </li>
          </ul>
        </div>
        <div class="about-dizhi-left-bottom">
          <h1 class="about-dizhi-title">联系我们</h1>
          <div class="about-dizhi-right-top-content" style="margin-top: 5px;">
            <p>联系地址：广州市天河区大观中路492号慧创百思产业园A140</p>
            <p>联系电话： 400-900-5991</p>
          </div>
        </div>
      </div>
      <div class="about-dizhi-right">
          <img src="@/assets/img/aboutUsDizhi.jpg" alt="" width="100%">
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      zxywList1: ['珠宝检测站入驻','珠宝检测业务系统','珠宝快速质检系统','智能拍照系统'],
      zxywList2: ['检测证书覆膜机','软件网站小程序定制','Al 非标机械设计研发',]
    }
  }
}
</script>

<style lang='scss'>
  .about-dizhi {
    display: flex;
    justify-content: space-between;
    align-items: center;
    >div {
      width: 48%;
    }
    .about-dizhi-title {
      font-weight: 600;
      font-size: 18px;
    }
    .about-dizhi-left {
      display: flex;
      flex-direction: column;
      .about-dizhi-left-top-content {
        display: flex;
        color: rgb(114,113,113);
        flex-wrap: wrap;
        li {
          padding: 0 10px;
          margin-top: 15px;
          border-right: 1px solid rgb(114,113,113);
        }
        li:first-child{
          padding-left: 0;
        }
        li:last-child{
          border-right: none;
        }
      }
      .about-dizhi-left-bottom {
        margin-top: 50px
      }
      .about-dizhi-right-top-content {
        color: rgb(114,113,113);
        p {
          margin-top: 15px;
        }
      }
    }
    padding: 40px 0 60px 0;
  }
</style>